export const initialVoucherForm = () => ({
  code: '', discount_type: 'fixed_amount', discount_value: '',
  maximum_discount_value: '', minimum_transaction_value: '',
  max_redemption_per_user: '1', expiration_date: '',
  active: true, is_promoted: false, promotional_text: '',
  applies_to_scope: 'all_items', product_category_codes: '', order_category_codes: '',
});

const blank = value => value == null || String(value).trim() === '';

export function wibExpiration(value) {
  if (blank(value)) return null;
  // Do not interpret a datetime-local value using the browser's own timezone.
  const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/);
  if (!match) throw new Error('Tanggal kedaluwarsa tidak valid.');
  const [, y, m, d, h, min] = match;
  const date = new Date(`${y}-${m}-${d}T00:00:00Z`);
  if (!Number.isFinite(date.getTime()) || date.getUTCFullYear() !== Number(y) ||
      date.getUTCMonth() + 1 !== Number(m) || date.getUTCDate() !== Number(d) ||
      Number(h) > 23 || Number(min) > 59) throw new Error('Tanggal kedaluwarsa tidak valid.');
  return `${value}:00+07:00`;
}

export function validateVoucherForm(form, now = Date.now()) {
  const errors = {};
  const code = String(form.code || '').trim();
  if (!code || code.length > 255) errors.code = 'Kode voucher wajib diisi (maksimal 255 karakter).';
  if (!['fixed_amount', 'percentage'].includes(form.discount_type)) errors.discount_type = 'Jenis diskon tidak valid.';
  if (!['all_items', 'product_categories', 'order_categories'].includes(form.applies_to_scope)) errors.applies_to_scope = 'Cakupan voucher tidak valid.';
  const value = Number(form.discount_value);
  if (blank(form.discount_value) || !Number.isFinite(value) || value <= 0) errors.discount_value = 'Nilai diskon harus lebih dari 0.';
  else if (form.discount_type === 'percentage' && (value < 1 || value > 100)) errors.discount_value = 'Persentase harus antara 1 dan 100.';
  else if (value > 999999.99) errors.discount_value = 'Nilai diskon maksimal Rp999.999,99 sesuai kapasitas data Bag Spa.';

  for (const [key, label] of [['maximum_discount_value', 'Maksimal diskon'], ['minimum_transaction_value', 'Minimum transaksi']]) {
    if (!blank(form[key]) && (!Number.isFinite(Number(form[key])) || Number(form[key]) < 0 || Number(form[key]) > 9999999999.99)) errors[key] = `${label} harus antara 0 dan 9.999.999.999,99.`;
  }
  for (const key of ['discount_value', 'maximum_discount_value', 'minimum_transaction_value']) {
    if (!blank(form[key]) && !errors[key] && Number(Number(form[key]).toFixed(2)) !== Number(form[key])) errors[key] = 'Gunakan maksimal 2 angka desimal.';
  }
  if (!/^[1-9]\d*$/.test(String(form.max_redemption_per_user)) || Number(form.max_redemption_per_user) > 2147483647) errors.max_redemption_per_user = 'Batas penggunaan harus berupa bilangan bulat minimal 1.';
  if (form.is_promoted && !String(form.promotional_text || '').trim()) errors.promotional_text = 'Teks promo wajib diisi jika Promoted dipilih.';
  if (String(form.promotional_text || '').trim().length > 255) errors.promotional_text = 'Teks promo maksimal 255 karakter.';
  if (form.applies_to_scope === 'product_categories' && !String(form.product_category_codes || '').split(/[,;\n]/).some(code => code.trim())) errors.product_category_codes = 'Isi minimal satu kode kategori produk.';
  if (form.applies_to_scope === 'order_categories' && !String(form.order_category_codes || '').split(/[,;\n]/).some(code => code.trim())) errors.order_category_codes = 'Isi minimal satu kode treatment.';
  try {
    const expiration = wibExpiration(form.expiration_date);
    if (expiration && Date.parse(expiration) <= now) errors.expiration_date = 'Tanggal kedaluwarsa harus di masa depan (WIB).';
  } catch (e) { errors.expiration_date = e.message; }
  return errors;
}

export function buildVoucherPayload(form) {
  return { voucher: {
    code: String(form.code || '').trim(),
    discount_type: form.discount_type,
    discount_value: Number(form.discount_value),
    maximum_discount_value: blank(form.maximum_discount_value) ? null : Number(form.maximum_discount_value),
    minimum_transaction_value: blank(form.minimum_transaction_value) ? null : Number(form.minimum_transaction_value),
    max_redemption_per_user: Number(form.max_redemption_per_user),
    expiration_date: wibExpiration(form.expiration_date),
    active: Boolean(form.active), is_promoted: Boolean(form.is_promoted),
    promotional_text: String(form.promotional_text || '').trim() || null,
    applies_to_scope: form.applies_to_scope,
    product_category_codes: form.applies_to_scope === 'product_categories' ? form.product_category_codes.trim() : '',
    order_category_codes: form.applies_to_scope === 'order_categories' ? form.order_category_codes.trim() : '',
  } };
}

export function voucherCreateError(error) {
  const messages = error?.data?.errors;
  if (Array.isArray(messages) && messages.length) return messages.join('\n');
  return error?.data?.error || error?.message || 'Gagal membuat voucher. Silakan coba lagi.';
}
